<div [style.minHeight.px]="45">
    <div class='_password-checker'
         [class._hidden]="!password">
        <div class="bg-col-4 w-12 m-t"
             [style.height.px]="2">
            <div class='bg-col-1 _strength'
                 [ngClass]="barColor"
                 [style.width.%]="passwordScore"
                 [style.height.%]="100">
            </div>
        </div>
        <div class="p2 m-t-1"
             [style.minHeight.px]='20'>{{passwordStrength | translate}}</div>
    </div>
</div>
